import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="columns" className="mx-auto w-full scroll-mt-24 px-4 py-14 md:px-10 md:py-20">
      <SectionHeading
        kicker="COLUMNS · 主题栏目"
        title="六个栏目，覆盖你想追的每一条线"
        description="娱乐、商界、科技、社会、圈内与深夜电台，每条线都有长期跟进的编辑。"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((item, index) => (
          <Link
            key={item.slug}
            to={`/category/${item.slug}`}
            className={`group relative flex h-56 flex-col justify-end overflow-hidden rounded-lg border border-background-200 transition-colors hover:border-primary-500/50 ${
              index === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
            }`}
          >
            <img
              src={item.image}
              alt={`${item.name}栏目 - 深夜爆料`}
              title={`${item.name} 深夜爆料 栏目`}
              className="absolute inset-0 h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/60 to-background-950/10"></div>
            <div className="relative p-5">
              <div className="mb-3 flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-950">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <span className="text-[10px] tracking-[0.22em] text-primary-300">
                  {item.english}
                </span>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-50">{item.name}</h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-300">
                {item.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-foreground-400">
                已发 {item.count} 条
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}